import { TFunction } from 'i18next';
import {
  AlertIcon,
  CometIcon,
  DashboardIcon,
  EditStarIcon,
  IntegrationIcon,
  LandingIcon,
  MessageEditIcon,
  QuestionIcon,
  UserBoltIcon,
} from '@/shared/ui';

const icons = [
  CometIcon,
  UserBoltIcon,
  EditStarIcon,
  MessageEditIcon,
  QuestionIcon,
  AlertIcon,
  LandingIcon,
  DashboardIcon,
  IntegrationIcon,
];

export const getBenefits = (t: TFunction) => {
  const benefits = t('pricingPage.benefits', { returnObjects: true }) as Array<{
    heading: string;
    description: string;
  }>;

  return benefits.map((benefit, index) => ({
    ...benefit,
    Icon: icons[index]!,
  }));
};
